// src/pages/po/ExportExcelModalContent.tsx
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@/icons';
import { apiPost } from '../../services/api';
import axios from 'axios';
import './ExportExcelModalContent.css';
import SaveButton from '../../components/common/SaveButton';
import { showAlert } from '../../contexts/DialogContext';
import { Toast } from '../../contexts/ToastContext';
import { logger } from '@/utils/logger';

interface ExportExcelModalContentProps {
  theme: 'dark' | 'light';
  onClose: () => void;
  allIdsAbertas: number[];
  allIdsFinalizadas: number[];
}

const ExportExcelModalContent: React.FC<ExportExcelModalContentProps> = ({
  theme,
  onClose,
  allIdsAbertas,
  allIdsFinalizadas,
}) => {
  const [selectedStatus, setSelectedStatus] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false); // Novo estado para carregamento

  const handleExport = async () => {
    if (!selectedStatus) {
      await showAlert('Selecione um status para exportar.', { variant: 'warning' });
      return;
    }

    const status = selectedStatus === 'Em Aberto' ? 'ABERTA' : 'FINALIZADO';
    const ordemCompraIds = selectedStatus === 'Em Aberto' ? allIdsAbertas : allIdsFinalizadas;

    if (ordemCompraIds.length === 0) {
      await showAlert(`Nenhuma ordem de compra ${selectedStatus.toLowerCase()} encontrada.`, { variant: 'info' });
      return;
    }

    setIsLoading(true); // Inicia o carregamento
    try {
      const response = await apiPost('/v1/ordens-compra/export-excel', {
        ordemCompraIds,
        status,
      }, {
        responseType: 'blob',
        blocking: true,
      });

      logger.log('Resposta da API:', response.data);

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `ordens-compra-${status.toLowerCase()}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      Toast.success('Arquivo Excel gerado com sucesso!');
      onClose();
    } catch (err) {
      logger.error('Erro ao exportar para Excel:', err);
      let errorMessage = 'Erro ao gerar o arquivo Excel. Tente novamente.';
      if (axios.isAxiosError(err)) {
        errorMessage = err.response?.data?.error || errorMessage;
        if (err.response?.status === 400) {
          errorMessage = 'O servidor retornou um erro: formato ou dados inválidos.';
        }
      }
      await showAlert(errorMessage, { variant: 'error' });
    } finally {
      setIsLoading(false); // Finaliza o carregamento
    }
  };

  return (
    <div className={`export-excel-modal-content ${theme}`}>
      <h2><FontAwesomeIcon icon={faFileExcel} /> Exportar para Excel</h2>
      <div className="form-group">
        <select
          id="status-select"
          value={selectedStatus}
          onChange={(e) => setSelectedStatus(e.target.value)}
          className="form-select"
        >
          <option value="">Selecione...</option>
          <option value="Em Aberto">Ordens de Compra Abertas</option>
          <option value="Finalizados">Ordens de Compra Finalizadas</option>
        </select>
      </div>
      <div className="modal-actions">
        <SaveButton
          isLoading={isLoading}
          onClick={handleExport}
          disabled={!selectedStatus || isLoading}
        />
      </div>
    </div>
  );
};

export default ExportExcelModalContent;